import { makeStyles } from "@material-ui/core/styles";

const IOSSwitchStyles = makeStyles((theme) => ({
  root: {
    width: 42,
    height: 26,
    padding: 0,
  },
  switchBase: {
    padding: 0,
    margin: 2,
    transitionDuration: '300ms',
    '&$checked': {
      transform: 'translateX(16px)',
      color: '#fff',
      '& + $track': {
        backgroundColor: '#0066ff',
        opacity: 1,
        border: 0,
      },
    },
    '&$focusVisible $thumb': {
      color: '#0066ff',
      border: '6px solid #fff',
    },
    '&$disabled $thumb': {
      color: theme.palette.grey[100],
    },
    '&$disabled + $track': {
      opacity: 0.5,
    },
  },
  thumb: {
    boxSizing: 'border-box',
    width: 22,
    height: 22,
  },
  track: {
    borderRadius: 13,
    backgroundColor: '#ccc',
    opacity: 1,
    transition: theme.transitions.create(['background-color'], {
      duration: 500,
    }),
  },
  checked: {},
  disabled: {},
  focusVisible: {},
}));

export { IOSSwitchStyles };
